import React from "react";
import {Icon, ff, form, modal, HorizontalLoader, FormActions} from "@mc/mc-legacy";
import { formValueSelector, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { Row, Col, Button, CardBody, Card, ModalHeader } from "reactstrap";
import "./KontaktyNotifikaceForm.scss";
import {TypNotifikace} from "../../pages/ProfilePage";
import {withLang} from "../../i18n/withLang";
import {i18n} from "../../i18n/i18n";

const FormBody = form.FormBody;

class GetKontaktForm extends React.Component<any, { overenyEmail?: string; overenyTelefon?: string }> {
  static formName = "getKontaktForm";

  constructor(props) {
    super(props);
  }

  render() {
    const { kontakt, typ, submitting, handleSubmit, onClose } = this.props;

    let icon;
    let info;
    switch (typ) {
        case TypNotifikace.EMAIL:
            icon = <Icon className={"kontakt-icon kontakt-email"} icon={"envelope"} />
            info = i18n(this.props.lang, `TypNotifikace_Verify_${typ}`)
            break;
        case TypNotifikace.TELEFON:
            icon = <Icon className={"kontakt-icon kontakt-telefon"} icon={"phone"} />
            info = i18n(this.props.lang, `TypNotifikace_Verify_${typ}`)
            break;
    }

    return (
      <form.Form className={"kontakty-notifikace-form"}>
        <FormBody>
            <h2 className={"mt-3 mb-3"}>{i18n(this.props.lang, "ProfilePage_notificationEnableTitle")}</h2>
          <Card className="mb-3">
            <CardBody className={"pl-0"}>
              <Row noGutters className={"m-1 align-items-center"}>
                <Col xs={"2"} className={"d-flex align-items-center justify-content-center p-1"}>
                    {icon}
                </Col>
                <Col className={"p-1"}>
                  <ff.String style={{height: "40px"}} label={false} name="kontakt" disabled={submitting} />
                </Col>
                <Col xs={"auto p-1 overit-button-action"}>
                    <Button  style={{height: "40px"}} className={"pl-3 pr-3 ml-1"} color={"primary"} type={"button"} disabled={submitting || !kontakt} onClick={handleSubmit}>
                        {i18n(this.props.lang, "ProfilePage_notificationVerify")}
                    </Button>
                </Col>
              </Row>
              <Row noGutters>
                  <Col xs={"2"} className={"pr-1"}/>
                  <Col xs={"10"}>
                      <div className={"pt-2"} style={{paddingLeft: "8px"}}>{info}</div>
                  </Col>
              </Row>

            </CardBody>
          </Card>

        </FormBody>
          <FormActions submitButton={false} cancelButton={false}>
              <Button className={"pl-3 pr-3"}  color="primary" outline onClick={onClose}>{i18n(this.props.lang, "button_cancel")}</Button>
          </FormActions>

      </form.Form>
    );
  }
}

function mapStateToProps(state, props) {
  const formName = props.form || GetKontaktForm.formName;
  const selector = formValueSelector(formName);
  return {
      kontakt: selector(state, "kontakt"),
  };
}

const reduxFormObj = reduxForm<any, any>({
  form: GetKontaktForm.formName
})(GetKontaktForm);
export default withLang(connect(mapStateToProps)(reduxFormObj));
